import Layout from "./Index.vue"

export default Layout